import { getTenantConfigWithDefaults, TenantConfig } from "./TenantConfiguration";
import { TenantName } from "../../types/TenantName";

export type Tenant = { name: TenantName } & TenantConfig;

class TenantService {
    async getTenant(): Promise<Tenant> {
        const response = await fetch("/services/api/tenant/", {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch tenant data. Status: ${response.status}`);
        }

        const name = (await response.text()) as TenantName;

        return getTenantConfigWithDefaults(name);
    }
}

export default new TenantService();
